<template>
  <b-card-code title="" no-body>
    <b-card-body>
      <h3>Total Krip : {{ rows }}</h3>
    </b-card-body>

    <b-card-body>
      <b-row>
        <b-col md="2" xl="2" class="mb-1">
          <!-- status krip -->
          <b-form-group label="Status Krip" label-for="status_krip">
            <validation-provider #default="{ errors }" name="status_krip">
              <v-select
                v-model="filter.krip_verified"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusKripVerified"
                placeholder="Pilih status verifikasi KRIP"
              />
            </validation-provider>
            <b>true:terverifikasi false:tidak terverifikasi</b>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- str no -->
          <b-form-group label="Nama Dokter" label-for="orang_nama_lengkap">
            <validation-provider
              #default="{ errors }"
              name="orang_nama_lengkap"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="orang_nama_lengkap"
                  placeholder="Search Nama Dokter"
                  v-model="filter.orang_nama_lengkap"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- str no -->
          <b-form-group label="Tanggal Dibuat" label-for="created_at">
            <validation-provider #default="{ errors }" name="Tanggal Dibuat">
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="created_at"
                  placeholder="Search Nama Dokter"
                  v-model="filter.created_at"
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col lg="2" md="2" class="mb-50">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-primary"
            class="mt-0 mt-md-2"
            @click="refreshPage()"
          >
            <feather-icon icon="SearchIcon" class="mr-25" />
            <span>Search</span>
          </b-button>
        </b-col>
      </b-row>

      <b-button-toolbar
        class="d-flex justify-content-between flex-wrap pt-0"
        aria-label="Toolbar with button groups and dropdown menu"
      >
        <!-- group -->
        <b-button-group>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="reloadPage"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </b-card-body>

    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      class="mb-0"
      @row-selected="onRowSelected"
    >
      <template #cell(document)="data">
        <a :href="data.item.document" v-if="data.item.document" target="_blank"
          >Open</a
        >
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(action)="data">
        <b-dropdown variant="link" no-caret toggle-class="p-0" right>
          <template #button-content>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </template>

          <b-dropdown-item @click="modalUpdateKrip(data.item)">
            <feather-icon icon="CheckSquareIcon" size="16" />
            <span class="align-middle ml-50">Verifikasi</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <!--pagination -->
      <div class="demo-inline-spacing pt-0">
        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          :total-rows="rows"
          :per-page="perPage"
        />
      </div>
    </b-card-body>
    <b-modal id="modal-export" hide-footer>
      <template #modal-title> Input Email Tujuan </template>
      <div class="d-block text-center">
        <p>
          Data yang akan diexport lebih dari <b>500</b> baris dan akan dikirim
          via email, Silahkan masukkan email anda!
        </p>
      </div>
      <b-form-group>
        <label for="email">Email:</label>
        <b-form-input
          id="email"
          type="email"
          placeholder="Email Address"
          v-model="email"
        />
      </b-form-group>
      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="exportData()"
      >
        <feather-icon icon="DownloadCloudIcon" /> Export
      </b-button>
    </b-modal>

    <b-modal
      id="modal-update-krip"
      title="Edit Krip"
      cancel-variant="outline-secondary"
      hide-footer
    >
      <b-form @submit.prevent>
        <b-form-input
          id="id_galeri"
          v-model="updateKrip.id"
          placeholder="Judul Galeri"
          hidden
        />
        <table style="width: 100%">
          <tr>
            <td>File</td>
            <td>:</td>
            <td v-if="updateKrip.krip_file != null">
              <a
                v-if="!updateKrip.krip_file.includes('https')"
                :href="
                  'https://www.idijakpus.or.id/uploads/krip/krip_file/' +
                    updateKrip.id +
                    '/' +
                    updateKrip.krip_file
                "
                >tampilkan file</a
              >
              <a v-else :href="updateKrip.krip_file" target="_blank"
                >tampilkan file</a
              >
            </td>
            <td v-else>
              <p><b>tidak ada file</b></p>
            </td>
          </tr>
        </table>

        <br />
        <b-form-group label="terferifikasi" label-for="vue-select">
          <v-select
            id="terferifikasi"
            v-model="updateKrip.krip_verified"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionSkp"
            placeholder="terferifikasi.."
          />
        </b-form-group>
        <br />
        <b-button
          variant="primary"
          type="submit"
          block
          :disabled="invalid"
          @click="updateDataKrip"
        >
          Update Krip
        </b-button>
      </b-form>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

import {
  BTable,
  BButton,
  BFormGroup,
  BAvatar,
  BBadge,
  BCardBody,
  BPagination,
  BFormTextarea,
  BFormFile,
  BButtonToolbar,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BRow,
  BCol,
  BModal,
} from "bootstrap-vue";
import API from "@/api";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCardCode,
    BTable,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    ValidationProvider,
    ValidationObserver,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BFormFile,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      currentPage: 1,
      rows: 0,
      perPage: 20,
      modes: ["multi", "single", "range"],
      fields: [
        { key: "id", label: "Id" },
        [{ key: "orang_id.orang_nama_lengkap", label: "Nama Dokter" }],
        [{ key: "krip_verified", label: "Status Verifikasi" }],
        [{ key: "krip_file", label: "File KRIP" }],
        [{ key: "created_at", label: "Tanggal Dibuat" }],
        [{ key: "updated_at", label: "Tanggal Diupdate" }],
        "action",
      ],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [
        {
          0: "Register",
          1: "Verify",
          2: "Can't find",
          3: "Input wrong data",
        },
        {
          0: "light-primary",
          1: "light-success",
          2: "light-warning",
          3: "light-warning",
          5: "light-info",
        },
      ],
      selectMode: "multi",
      selected: [],
      statusKripVerified: ["true", "false"],

      search: null,
      detailPendidikan: {},
      detailGaleri: {},
      updateKrip: {},
      optionSkp: ["false", "true"],
      filter: {
        krip_verified: null,
        orang_nama_lengkap: null,
        created_at: null,
      },
    };
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    refreshPage() {
      if (this.currentPage == 1) {
        this.getKrip();
      } else {
        this.currentPage = 1;
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      }
      return `${files.length} files selected`;
    },

    modalUpdateKrip(item) {
      this.updateKrip = item;
      this.$bvModal.show("modal-update-krip");
    },

    reloadPage() {
      location.reload();
    },

    async getKrip() {
      try {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", true);

        const form = {
          limit: this.perPage,
          page: this.currentPage,
          search: this.search,
          ...this.filter,
        };
        const { data } = await API.krip.list(form);
        this.data_table = data;
        this.items = data.data;
        this.rows = data.total;

        this.handleMsgSuccess("Berhasil tampilkan data Krip");
      } catch (error) {
        console.log(error);
        this.handleMsgErrors(error, "Terjadi kesalahan silahkan coba lagi!");
      } finally {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", false);
      }
    },

    async updateDataKrip() {
      try {
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", true);

        var ids = this.updateKrip.id;

        let body = {
          krip_verified: this.updateKrip.krip_verified,
        };
        const { data } = await API.krip.updateData(ids, body);
        this.handleMsgSuccess("Berhasil Update Krip");
        this.refreshPage();
      } catch (error) {
        console.log(error);
        this.handleMsgErrors(error, "gagal update Krip");
      } finally {
        this.$bvModal.hide("modal-update-krip");
        this.clearSelected();
        this.$store.commit("SET_IS_LOADING_FOR_SUBMIT", false);
      }
    },
  },
  mounted() {
    this.getKrip();
  },
  watch: {
    currentPage() {
      this.getKrip();
    },
  },
};
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
